module.exports = __webpack_public_path__ + "static/media/sonder-preview.26d7a6f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/blog/sonder-preview.jpg
// module id = 369
// module chunks = 0